import { mapDTO } from '@twistezo/ts-dto-mapper'
import _ from 'lodash'

import type { AdUnitTableSchema } from 'features/inventory/ad-unit/forms/AdUnitTableForm/schema'
import type { DirtyAdUnitsAttributes } from 'features/inventory/ad-unit/forms/AdUnitTableForm/types'
import type { UpdateAdUnitsMutationVariables } from 'gql/graphql'

type From = AdUnitTableSchema
type To = UpdateAdUnitsMutationVariables['input']

export const toDTO = ({
  data,
  dirtyAdUnitsAttributes = {},
}: {
  data: From
  dirtyAdUnitsAttributes?: DirtyAdUnitsAttributes
}): To =>
  mapDTO<From, To>({ from: data }).transform(
    ({ adUnitsAttributes }: From): To => ({
      adUnitsAttributes: Object.entries(dirtyAdUnitsAttributes).map(
        ([id, dirtyFields]: [string, DirtyAdUnitsAttributes[string]]) => ({
          id,
          ..._.pick(adUnitsAttributes[id], _.keys(_.pickBy(dirtyFields))),
        }),
      ),
    }),
  )
